module.exports = __webpack_public_path__ + "img/logo.86c6c30a.svg";